module.exports = __webpack_public_path__ + "static/media/3.0b472e17.jpg";